import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { DriverJurisdictionTextField, ExplanationAccordion } from 'components'
import { PersonDriverInformationDto, personDriverInformationValidationSchema } from 'dtos'
import { Formik } from 'formik'

interface DriverInformationAddEditDialogProps {
  initialValues: PersonDriverInformationDto
  loading: boolean
  onClose: () => void
  onSave: (values: any) => void
  open: boolean
}

export default function DriverInformationAddEditDialog({
  initialValues,
  loading,
  onClose,
  onSave,
  open
}: DriverInformationAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validateOnBlur={false}
        validateOnChange={true}
        validationSchema={personDriverInformationValidationSchema}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Edit Driver Information</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.driverCrewMember && errors.driverCrewMember)}
                      helperText={touched.driverCrewMember && errors.driverCrewMember}
                      label='Crew Member'
                      name='driverCrewMember'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.driverCrewMember}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.driverVehiclePlate && errors.driverVehiclePlate)}
                      helperText={touched.driverVehiclePlate && errors.driverVehiclePlate}
                      label='Vehicle Plate'
                      name='driverVehiclePlate'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.driverVehiclePlate}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <DriverJurisdictionTextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.driverVehicleCountry && errors.driverVehicleCountry)}
                      helperText={touched.driverVehicleCountry && errors.driverVehicleCountry}
                      label='Vehicle Country'
                      name='driverVehicleCountry'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.driverVehicleCountry}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <DriverJurisdictionTextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.driverVehicleState && errors.driverVehicleState)}
                      helperText={touched.driverVehicleState && errors.driverVehicleState}
                      label='Vehicle State'
                      name='driverVehicleState'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.driverVehicleState}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.driverTrailerPlate && errors.driverTrailerPlate)}
                      helperText={touched.driverTrailerPlate && errors.driverTrailerPlate}
                      label='Trailer Plate'
                      name='driverTrailerPlate'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.driverTrailerPlate}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <DriverJurisdictionTextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.driverTrailerCountry && errors.driverTrailerCountry)}
                      helperText={touched.driverTrailerCountry && errors.driverTrailerCountry}
                      label='Trailer Country'
                      name='driverTrailerCountry'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.driverTrailerCountry}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <DriverJurisdictionTextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.driverTrailerState && errors.driverTrailerState)}
                      helperText={touched.driverTrailerState && errors.driverTrailerState}
                      label='Trailer State'
                      name='driverTrailerState'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.driverTrailerState}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <ExplanationAccordion variant='outlined'>||No fields are required. ||</ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} color='inherit' onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
